const RemoteDataMap = new Map();

const Util = {
  addData(id, data) {
    RemoteDataMap.set(id, data);
  },
  getData(id) {
    return RemoteDataMap.get(id);
  },
};
export default Util;
